module.exports = __webpack_public_path__ + "img/bg_znzd1.ea0141a4.png";